import DataTable from "react-data-table-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { FaWhatsapp } from "react-icons/fa6";
import MandalAdminLayout from "../../../components/MandalAdminLayout/MandalAdminLayout";

function ReportTable() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [reportDetails, setReportDetails] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location?.state || {};
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "MandalAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
  }, []);

  useEffect(() => {
    handleSearch();
  }, [search, reportDetails]);

  const fetchRecords = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(`${apiURL}/ReportDetails/Get`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data?.data || [];
      const reversed = [...data].reverse();
      setReportDetails(reversed);
      setFilteredData(reversed);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error.response?.data?.message);
    }
  };

  const handleSearch = () => {
    if (!search) {
      setFilteredData(reportDetails);
      return;
    }

    const lowercasedSearch = search.toLowerCase();

    const filtered = reportDetails.filter((row) => {
      const date = `${row.date}`.toLowerCase();
      const santo1 = `${row.santo1}`.toLowerCase();
      const santo2 = `${row.santo2}`.toLowerCase();
      const agresar = `${row.agresar}`.toLowerCase();
      const contactNumbers = [row.contactNo]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return (
        date.includes(lowercasedSearch) ||
        santo1.includes(lowercasedSearch) ||
        santo2.includes(lowercasedSearch) ||
        agresar.includes(lowercasedSearch) ||
        contactNumbers.includes(lowercasedSearch)
      );
    });

    setFilteredData(filtered);
  };

  const handleDelete = async (rowId) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this record?",
    );
    if (!confirmed) return;

    try {
      const response = await axios.delete(
        `${apiURL}/ReportDetails/Delete?id=${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      toast.success(response?.data?.message);
      fetchRecords();
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };

  const handleWhatsAppClick = (link) => {
    if (!link) return;

    // Extract phone number and text from the link
    const url = new URL(link);
    const phoneNumber = new URLSearchParams(url.search).get("phone");
    const text = new URLSearchParams(url.search).get("text");

    if (!phoneNumber || !text) return;

    // Decode the text and properly format it while keeping bold formatting
    const formattedText = decodeURIComponent(text)
      .replace(/%0A/g, "\n") // Convert encoded new lines to actual new lines
      .trim();

    // Create a new WhatsApp link with the formatted message
    const whatsappLink = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodeURIComponent(
      formattedText,
    )}`;
    window.open(whatsappLink, "_blank");
  };

  const columns = [
    {
      name: "No",
      selector: (_, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: true,
      width: "65px",
      center: "true",
    },
    {
      name: "Date",
      selector: (row) => row.date?.slice(0, 10),
      sortable: true,
      width: "100px",
      center: "true",
    },
    {
      name: "Santo 1",
      selector: (row) => row.santo1,
    },
    {
      name: "Santo 2",
      selector: (row) => row.santo2,
    },
    {
      name: "Agresar",
      selector: (row) => row.agresar,
      width: "130px",
    },
    {
      name: "Mobile Number",
      selector: (row) => row.contactNo,
    },

    {
      name: "Actions",
      width: "160px",
      cell: (row) => (
        <div>
          <button
            type="button"
            className="btn btn-primary btn-sm mr-1"
            onClick={() =>
              navigate("/update-report2", {
                state: { reportId: row.id, id: id },
              })
            }
          >
            <i className="fas fa-pen"></i>
          </button>
          <button
            type="button"
            className="btn btn-danger btn-sm mr-1"
            onClick={() => handleDelete(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
          <button
            type="button"
            className="btn btn-success btn-sm mr-1"
            disabled={!row.link}
            onClick={() => handleWhatsAppClick(row.link)}
          >
            <FaWhatsapp />
          </button>
        </div>
      ),
      center: "true",
    },
  ];

  return (
    <MandalAdminLayout ac3="active">
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h5>Report Details</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/mandal-admin-dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Report List</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex justify-content-between">
                    <div className="bd-highlight">
                      <input
                        className="form-control mb-3"
                        type="search"
                        placeholder="Search"
                        title="Search within table"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    <div className="bd-highlight"></div>
                    <div className="bd-highlight">
                      <Link to="/add-report2" state={{ id: id }}>
                        <button
                          type="button"
                          className="btn btn-primary px-md-4 py-md-2 px-2 py-2"
                        >
                          <i className="fas fa-plus"></i> Add
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="card-body text-center">
                  {loading ? (
                    <>
                      {" "}
                      <span
                        className="spinner-border spinner-border-sm "
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </>
                  ) : (
                    <DataTable
                      columns={columns}
                      data={filteredData}
                      pagination
                      responsive
                      className="custom-table"
                      onChangePage={(page) => setCurrentPage(page)}
                      onChangeRowsPerPage={(newPerPage) => {
                        setRowsPerPage(newPerPage);
                        setCurrentPage(1);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </MandalAdminLayout>
  );
}

export default ReportTable;
